import React, { useContext } from "react";
import { IoStar } from "react-icons/io5";
import { FaArrowRightLong } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { AuthContext } from "../../context/AuthContext";

type Review = {
  description: string;
  name: string;
  position: string;
};

const reviews: Review[] = [
  {
    name: "Nicholas Donarski",
    position: "Founder",
    description:
      "I am amazed to see the quality of work that Techqilla did for me. Awesome Designers and awesome team.",
  },

  {
    name: "Jonah Havel",
    position: "Software Developer and Military Operation",
    description:
      "It's a  very professional company that leaves no requirement and opinion pending. The staff is also very friendly and innovative.",
  },
  {
    name: "Carl G Morris",
    position: "CEO (Envision Travel Group)",
    description:
      "Wonderful communication, rapid response, excellent listner,detailed oriented, great suggestions, exercise foresight, goal oriented, time conscious having your best  interest in mind",
  },
  {
    name: "Shawn Piatz",
    position: "VPO",
    description:
      "Techqilla was fantastic to work  with! Diksha, Vishesh, Sakshi and the whole staff are creative, Intelligent people who helped us meet  our need and expand our audience on social media.",
  },
  {
    name: "Lucas Hamrick",
    position: "Chief Executive Office",
    description:
      "Honestly I am so satisfied with thier work after wandering companies  to companies I finally found the perfect partner that provides great strategies for my business",
  },
];

const Reviews = () => {
  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div
      className={`${
        theme === "dark" ? " bg-white text-black" : "bg-black text-white"
      } py-20 px-4 sm:px-20 flex flex-col items-center gap-4 justify-between w-full z-0`}
    >
      <div className="max-w-screen-2xl w-full sm:mb-8">
        <h2
          className={`text-3xl bricolage-grotesque-bold  sm:mb-10 sm:text-5xl text-center sm:text-left`}
        >
          Success Stories
        </h2>
        <div className="flex w-full flex-col justify-between sm:items-end sm:flex-row gap-10">
          <div className="flex justify-center gap-4 mt-4 sm:mt-0">
            <div className="flex items-center gap-2">
              <h2 className="text-3xl font-extrabold font-gtAmerica  mb-4 sm:mb-8 sm:text-5xl">
                12
              </h2>
              <p className="text-sm font-gtAmerica">Verified reviews</p>
            </div>
            <div className="flex items-center gap-2">
              <h2 className="text-3xl font-extrabold font-gtAmerica  mb-4 sm:mb-8 sm:text-5xl">
                5.0
              </h2>
              <p className="text-sm font-gtAmerica">Ratings</p>
            </div>
          </div>
          <p className="text-xl mb-4 sm:mb-10 font-gtAmerica font-semibold sm:w-[350px] text-center sm:text-start">
            Our <span className="text-primary">clients’ reviews </span> clearly
            demonstrate how efficient our collaborative approach is.
          </p>
        </div>
        <div
          className={`${
            theme === "dark" ? "border-secondary" : "border-white"
          } w-full h-[100px] rounded-r-full rounded-l-full -mt-10 border-b-2 hidden sm:block`}
        ></div>
      </div>
      <div className="max-w-screen-2xl w-full flex justify-center items-center">
        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          className="flex justify-center items-center py-4"
          pagination={{
            el: ".swiper-pagination",
            type: "progressbar",
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 10,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            1440: {
              slidesPerView: 4,
              spaceBetween: 20,
            },
          }}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          loop
          autoplay={true}
        >
          {reviews.map((review, index) => (
            <SwiperSlide className="!flex justify-center py-8" key={index}>
              <div
                className={`${
                  theme === "dark"
                    ? "bg-white text-black border-2 hover:bg-primary hover:text-white"
                    : " bg-[#141414] text-white border border-black hover:border-secondary hover:shadow-[0_0_40px_#8d19da]"
                } h-[300px] sm:h-[400px] font-gtAmerica  sm:max-w-[350px] rounded-2xl sm:rounded-[40px] sm:px-4 py-4 sm:py-8  transition-custom group flex flex-col items-center sm:items-start justify-between`}
              >
                <div className="flex items-center gap-2  mb-8 mx-4 sm:mx-6">
                  <IoStar
                    className={`${
                      theme === "dark"
                        ? "text-primary group-hover:text-white"
                        : "text-secondary group-hover:text-white"
                    } transition-all duration-500`}
                  />
                  <IoStar
                    className={`${
                      theme === "dark"
                        ? "text-primary group-hover:text-white"
                        : "text-secondary group-hover:text-white"
                    } transition-all duration-500`}
                  />
                  <IoStar
                    className={`${
                      theme === "dark"
                        ? "text-primary group-hover:text-white"
                        : "text-secondary group-hover:text-white"
                    } transition-all duration-500`}
                  />
                  <IoStar
                    className={`${
                      theme === "dark"
                        ? "text-primary group-hover:text-white"
                        : "text-secondary group-hover:text-white"
                    } transition-all duration-500`}
                  />
                  <IoStar
                    className={`${
                      theme === "dark"
                        ? "text-primary group-hover:text-white"
                        : "text-secondary group-hover:text-white"
                    } transition-all duration-500`}
                  />
                  <span
                    className={`${
                      theme === "dark"
                        ? "text-primary group-hover:text-white"
                        : "text-secondary group-hover:text-white"
                    } transition-all duration-500 font-gtAmerica`}
                  >
                    5.0
                  </span>
                </div>
                <p className="text-sm sm:text-lg  mx-4 sm:mx-6 text-center sm:text-left">
                  {review.description}
                </p>
                <div className="flex flex-col items-center sm:items-start">
                  <p className="font-bold pt-8  text-sm mx-4 sm:mx-6">
                    {review.name}
                  </p>
                  <p className="font-bold pt-2  text-sm mx-4 sm:mx-6">
                    {review.position}
                  </p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="relative w-full max-w-[300px]">
        <div className="swiper-pagination pagination-progress h-2"></div>
      </div>

      <div className="flex gap-2 relative z-10 mt-5">
        <div className="swiper-button-prev p-4 bg-primary hover:bg-white [&>*]:hover:text-black transition-custom rounded-full border border-gray-400">
          <FaArrowRightLong className="text-white rotate-180" />
        </div>

        <div className="swiper-button-next p-4 bg-primary hover:bg-white [&>*]:hover:text-black transition-custom rounded-full border border-gray-400">
          <FaArrowRightLong className="text-white" />
        </div>
      </div>
    </div>
  );
};

export default Reviews;
